module.exports = __webpack_public_path__ + "static/media/portret.c6934b20.webp";